import { SubscriptionStatus } from "@brookbush/database";
import type { SubscriptionExpanded } from "@brookbush/types";

import { type FormEventHandler, useState } from "react";

import Button from "~/components/Button";
import { useStripeSubscription, useSubscriptionDB } from "~/hooks";
import useCheckout from "~/hooks/useCheckout";

const BecomeAMemberEndTrial = () => {
	const { subscription, endTrial } = useStripeSubscription();

	const { completeCheckout } = useCheckout();
	const { refreshSubscriptionDB, subscriptionDB } = useSubscriptionDB();

	const [isLoading, setIsLoading] = useState(false);

	const [error, setError] = useState<string | null>(null);

	const handleSubmit: FormEventHandler<HTMLFormElement> = async (e) => {
		setIsLoading(true);

		e.preventDefault();

		try {
			await endTrial();
			refreshSubscriptionDB(
				{
					...subscriptionDB,
					status: SubscriptionStatus.ACTIVE,
				} as SubscriptionExpanded,
				{ revalidate: false },
			);
		} catch (_error) {
			setError("Something went wrong! Contact support.");
			setIsLoading(false);
		}
		completeCheckout("stripe");
		setIsLoading(false);
	};

	return (
		<form onSubmit={handleSubmit} className="flex flex-col gap-6">
			<p className="rounded-xl border border-orange-600/20 bg-orange-50 px-3 py-2 font-medium text-orange-900 text-sm dark:border-orange-300/40 dark:bg-orange-300/20 dark:text-orange-100">
				Your trial is set to end on{" "}
				<span className="font-semibold text-orange-800 dark:text-orange-200">
					{new Date(subscription?.trial_end! * 1000).toDateString()}
				</span>
				, but you can activate your member instantly and get unlimited access.
			</p>

			<Button className="w-full" disabled={isLoading} type="submit">
				Click To Pay
			</Button>

			{error && <span className="mt-1 text-red-500 text-sm">{error}</span>}
		</form>
	);
};

export default BecomeAMemberEndTrial;
